import React from 'react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Zap, Volume2 } from 'lucide-react';
const scrollToOrder = () => {
  document.getElementById('order-section')?.scrollIntoView({
    behavior: 'smooth'
  });
};
const scrollToProducts = () => {
  document.getElementById('paquete-completo')?.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
};
export function HeroSection() {
  return <Section className="min-h-[90vh] flex flex-col justify-center items-center text-center bg-transparent pt-32 pb-20" data-id="element-68">
      <div className="flex flex-col items-center space-y-8 max-w-4xl mx-auto" data-id="element-69">
        <span className="inline-block py-1 px-3 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] text-sm font-medium tracking-wider uppercase backdrop-blur-sm bg-black/30" data-id="element-70">
          Sistema Anticaos™
        </span>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-[1.1] drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)] text-center" data-id="element-71">
          Descubre el Método Definitivo para{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#F5D76E] drop-shadow-none" data-id="element-72">
            Construir Disciplina
          </span>{' '}
          y Estabilidad
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 font-light max-w-2xl leading-relaxed drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)] text-center" data-id="element-73">
          Incluso cuando la motivación desaparece. Transforma el caos en hábitos
          consistentes y resultados reales.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="max-w-xl w-full" data-id="element-74">
          <motion.div animate={{
          boxShadow: ['0 0 18px rgba(212, 175, 55, 0.6), 0 0 40px rgba(212, 175, 55, 0.3)', '0 0 25px rgba(212, 175, 55, 0.9), 0 0 60px rgba(212, 175, 55, 0.5)', '0 0 18px rgba(212, 175, 55, 0.6), 0 0 40px rgba(212, 175, 55, 0.3)']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative p-6 md:p-8 rounded-2xl border-2 border-[#D4AF37] bg-black/70 backdrop-blur-xl" data-id="element-75">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-76">
              <Volume2 className="w-5 h-5 text-[#D4AF37]" data-id="element-77" />
              <p className="text-[#f5e7b0] font-bold text-sm uppercase tracking-widest text-center" data-id="element-78">
                Dale play y siente el método
              </p>
            </div>

            {/* Google Drive Audio Player - cropped to hide Drive link */}
            <div className="relative rounded-lg overflow-hidden flex items-center justify-center" style={{
            height: '48px'
          }} data-id="element-79">
              <iframe src="https://drive.google.com/file/d/1SOyAWPY1wXtFkpa0igMRSjy9FWDUTSe6/preview" width="100%" height="80" allow="autoplay" style={{
              border: 0,
              position: 'absolute',
              bottom: '-22px',
              left: 0
            }} data-id="element-80" />
            </div>

            <p className="text-xs text-gray-400 text-center mt-3 tracking-wide" data-id="element-81">
              Audio libro completo (1:09:58)
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="pt-4 flex justify-center" data-id="element-82">
          <div onClick={scrollToProducts} className="inline-flex flex-col items-center gap-4 p-6 md:p-8 rounded-2xl bg-black/60 backdrop-blur-md border border-[#D4AF37]/40 relative overflow-hidden cursor-pointer hover:border-[#D4AF37]/70 transition-colors shadow-2xl" data-id="element-83">
            {/* Animated glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37]/0 via-[#D4AF37]/10 to-[#D4AF37]/0 animate-pulse" data-id="element-84" />

            {/* Discount Badge */}
            <motion.div animate={{
            boxShadow: ['0 0 20px rgba(212, 175, 55, 0.3)', '0 0 40px rgba(212, 175, 55, 0.5)', '0 0 20px rgba(212, 175, 55, 0.3)']
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="relative flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-[#D4AF37] to-[#F5D76E]" data-id="element-85">
              <Zap className="w-6 h-6 text-[#0A0A0A] fill-current" data-id="element-86" />
              <span className="text-2xl md:text-3xl font-black text-[#0A0A0A] tracking-tight" data-id="element-87">
                80% DESCUENTO
              </span>
            </motion.div>

            {/* Price Display */}
            <div className="relative z-10 flex flex-col items-center gap-2 text-center" data-id="element-88">
              <div className="flex items-center justify-center gap-3" data-id="element-89">
                <span className="text-xl text-gray-400 line-through" data-id="element-90">
                  $555.00 MXN
                </span>
                <span className="text-xs uppercase tracking-wider text-[#D4AF37] font-semibold px-2 py-1 bg-[#D4AF37]/20 rounded" data-id="element-91">
                  Oferta Limitada
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-1" data-id="element-92">
                <span className="text-lg text-gray-300" data-id="element-93">Solo</span>
                <span className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#F5D76E]" data-id="element-94">
                  $111.19 MXN
                </span>
              </div>
              <p className="text-sm text-gray-400 mt-1 text-center" data-id="element-95">
                Pago único • Acceso de por vida
              </p>
            </div>
          </div>
        </motion.div>

        <div className="pt-4 flex flex-col items-center" data-id="element-96">
          <Button onClick={scrollToProducts} className="text-lg px-10 py-5" data-id="element-97">
            Obtener Acceso Inmediato
          </Button>
          <p className="mt-4 text-sm text-gray-400 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)] text-center" data-id="element-98">
            Acceso instantáneo • Garantía de 30 días
          </p>
        </div>
      </div>
    </Section>;
}